export default {"src":"/_next/static/media/vendor-icon.c0f95da5.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};